// TODO: refactor this
import React, { useState, ReactNode } from 'react'
import Select, { SelectProps } from 'react-select'
import AsyncSelect from 'react-select/async'
import AsyncCreatableSelect from 'react-select/async-creatable'
import { FormikProps } from 'formik'
import { InputAdornment } from '@material-ui/core'
import { ISelectInput } from '../../types/pack'
import { trace } from '../../services/common'
import { SelectWithValidation } from './SelectWithValidation'
import { CustomFieldGroup } from '../CustomFieldGroup'
import { customComponents } from './AsyncCreatableComponents'

interface ITypeaheadSelect {
  form?: FormikProps<any>
  field?: {
    name: string
    value: ISelectInput[]
    onBlur: () => void
  }
  changeListener: (inputs: any[]) => void
  label: string
  disabled: boolean
  loadOptions: (inputValue: string, callback: (items: any[]) => void) => void
  noOptionsMessage?: ({ inputValue }: { inputValue: string }) => string
  noAsync: boolean
  isCreatable: boolean
  validateImmediately?: boolean
  defaultValueAdornment?: ReactNode
}

// Use only for Formik Field as custom component
// TODO: seperate formik logic and general autocomplite behaviour
// if not - add prefix "Custom" to the name
export const TypeaheadSelect = (props: ITypeaheadSelect & SelectProps) => {
  const [isDisabled, setIsDisabled] = useState(false)
  const {
    form,
    field,
    changeListener,
    label,
    disabled,
    loadOptions,
    noOptionsMessage,
    noAsync,
    isCreatable,
    validateImmediately,
    defaultValueAdornment,
  }: ITypeaheadSelect = props
  const changeHandler = async (fieldName: string, fieldData: any) => {
    try {
      setIsDisabled(true)
      if (form) {
        const modifiedInputs =
          props.onChange && (await props.onChange(fieldData))
        form.setFieldValue(fieldName, modifiedInputs || fieldData || [])
      }
      if (changeListener) {
        changeListener(fieldData)
      }
    } catch (err) {
      trace(err)
    } finally {
      setIsDisabled(false)
    }
  }

  const blurHandler = () => {
    if (field) {
      field.onBlur()
    }
    if (form && field) {
      form.setFieldTouched(field.name)
    }
  }

  const error = (form &&
    field &&
    (form.touched[field.name] || validateImmediately) &&
    form.errors[field.name]) as string | false | undefined
  const name = field?.name || props.name

  const commonConfig = {
    id: name,
    name,
    textFieldProps: {
      label,
      name,
      InputLabelProps: {
        shrink: true,
      },
      error: !!error,
      disabled,
    },
    components: customComponents,
    isClearable: false,
    value: field?.value || props.value,
    onChange: changeHandler.bind(null, name),
    onBlur: blurHandler,
    loadOptions,
    noOptionsMessage,
    isDisabled: isDisabled || disabled,
    endAdornment: !!defaultValueAdornment && (
      <InputAdornment position="end">{defaultValueAdornment}</InputAdornment>
    ),
    ...props,
  }

  const NonCreatableComponent = noAsync ? Select : AsyncSelect

  return (
    <CustomFieldGroup error={error}>
      {isCreatable ? (
        <SelectWithValidation
          component={AsyncCreatableSelect}
          {...commonConfig}
        />
      ) : (
        <NonCreatableComponent {...commonConfig} />
      )}
    </CustomFieldGroup>
  )
}
